import { paymentType as PaymentType } from '@ourbranch/lookups';
import { isFarmBasedPolicyType } from '@ourbranch/farm-utils';
import { differenceInCalendarDays, getDate, addMonths, setDate } from 'date-fns';
import { awsDateToDateObject } from 'core/helpers/formatters';

// next available billing date of month AFTER the effective date of the policy
const firstInstallmentBillingDate = (effectiveDate, billingDayOfMonth) => {
  return setDate(addMonths(effectiveDate, getDate(effectiveDate) > billingDayOfMonth ? 1 : 0), billingDayOfMonth);
};

// if our next installment payment is within 15 days of the bind date, we offer megadownpay
// export const canOfferMegaDownPay = (effectiveDateIn, billingDayOfMonth, paymentType) => {
export const canOfferMegaDownPay = (effectiveDateIn, billingDayOfMonth, paymentType) => {
  if (effectiveDateIn && billingDayOfMonth && paymentType) {
    const effectiveDate = awsDateToDateObject(effectiveDateIn);
    const bindDate = new Date();
    return (
      paymentType === PaymentType.Monthly &&
      differenceInCalendarDays(firstInstallmentBillingDate(effectiveDate, billingDayOfMonth), bindDate) <= 15 &&
      getDate(effectiveDate) !== billingDayOfMonth
    );
  }
  return false;
};

// if our first payment date is the same as our effective date, we need to require the megadownpay
export const isMegaDownPayRequired = (effectiveDateIn, billingDayOfMonth, paymentType) => {
  if (effectiveDateIn && billingDayOfMonth && paymentType) {
    const effectiveDate = awsDateToDateObject(effectiveDateIn);
    const firstPaymentDate = firstInstallmentBillingDate(effectiveDate, billingDayOfMonth);
    return paymentType === PaymentType.Monthly && differenceInCalendarDays(firstPaymentDate, effectiveDate) === 0;
  }
  return false;
};

// returns a new global object with correctly configured megadownpay
export const setMegaDownPayOnOffer = (details) => {
  const { global } = details;
  let updatedAutoMegaDownPay = global.autoMegaDownPay;
  let updatedHomeMegaDownPay = global.homeMegaDownPay;
  let updatedRentersMegaDownPay = global.rentersMegaDownPay;
  let updatedCondoMegaDownPay = global.condoMegaDownPay;
  let updatedFarmMegaDownPay = global.farmMegaDownPay;

  if (details.selectedOption?.includes('A') && global.autoMegaDownPay) {
    updatedAutoMegaDownPay =
      canOfferMegaDownPay(global.autoEffectiveDate, global.autoBillingDayOfMonth, global.autoPaymentType) || null;
  }

  if (details.selectedOption?.includes('H') && global.homeMegaDownPay) {
    updatedHomeMegaDownPay =
      canOfferMegaDownPay(global.homeEffectiveDate, global.homeBillingDayOfMonth, global.homeownersPaymentType) || null;
  }

  if (details.selectedOption?.includes('R') && global.rentersMegaDownPay) {
    updatedRentersMegaDownPay =
      canOfferMegaDownPay(global.rentersEffectiveDate, global.rentersBillingDayOfMonth, global.rentersPaymentType) ||
      null;
  }

  if (details.selectedOption?.includes('C') && global.condoMegaDownPay) {
    updatedCondoMegaDownPay =
      canOfferMegaDownPay(global.condoEffectiveDate, global.condoBillingDayOfMonth, global.condoPaymentType) || null;
  }

  if (isFarmBasedPolicyType(details.selectedOption) && global.farmMegaDownPay) {
    updatedFarmMegaDownPay =
      canOfferMegaDownPay(global.farmEffectiveDate, global.farmBillingDayOfMonth, global.farmPaymentType) || null;
  }

  return {
    ...global,
    homeMegaDownPay: updatedHomeMegaDownPay,
    autoMegaDownPay: updatedAutoMegaDownPay,
    rentersMegaDownPay: updatedRentersMegaDownPay,
    condoMegaDownPay: updatedCondoMegaDownPay,
    farmMegaDownPay: updatedFarmMegaDownPay
  };
};
